export default __webpack_public_path__ + "static/media/news3.c899226d.mp4";